<template>
  <content-panel class="maintenance-page">
    <template v-slot:search>
      <search-box class="search-box">
        <el-form
          :model="filter"
          inline
          size="mini"
          label-width="110px"
          @submit.native.prevent="search"
        >
          <el-form-item label="包件编码">
            <el-input
              v-model.trim="filter.packCode"
              clearable
              placeholder="精确查询"
              @keyup.enter.native="search"
            />
          </el-form-item>
          <el-form-item label="包件名称">
            <el-input
              v-model.trim="filter.packName"
              clearable
              placeholder="精确查询"
              @keyup.enter.native="search"
            />
          </el-form-item>
          <el-form-item label="上架分类">
            <el-select v-model="filter.classCodes" multiple clearable>
              <el-option
                v-for="item in shelfOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="生产物流分类">
            <el-select
              v-model="filter.productionDeliveryClassCodes"
              multiple
              clearable
            >
              <el-option
                v-for="item in productionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>

        <template v-slot:right>
          <el-button type="primary" size="small" :loading="loading" @click="search">
            查询
          </el-button>
          <el-button class="orange-btn" size="small" @click="reset">
            重置
          </el-button>
        </template>
      </search-box>
    </template>

    <template v-slot:sub>
      <el-alert
        title="包件分类配置保存后从下一个数据版本生效。"
        type="info"
        :closable="false"
        show-icon
      />
      <el-alert v-if="error" :title="error" type="error" :closable="false">
        <el-button type="text" @click="initialize">重新加载</el-button>
      </el-alert>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-left>包件分类配置</template>
      <template v-slot:header-right>
        <el-button size="mini" type="primary" @click="edit()">
          新增
        </el-button>
        <el-button size="mini" type="primary" @click="importVisible = true">
          批量导入
        </el-button>
        <el-button size="mini" @click="downLoadTemplate">
          下载模板
        </el-button>
      </template>

      <el-table
        v-loading="loading"
        :data="rows"
        :height="maxTableHeight"
        border
        size="small"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        empty-text="暂无符合条件的记录"
        element-loading-text="数据加载中"
      >
        <el-table-column
          prop="packCode"
          label="包件编码"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="packName"
          label="包件名称"
          min-width="190"
          show-overflow-tooltip
        />
        <el-table-column
          prop="className"
          label="上架分类"
          min-width="150"
          show-overflow-tooltip
        />
        <el-table-column
          prop="productionDeliveryClassName"
          label="生产物流分类"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column prop="operatorName" label="更新人" width="120" />
        <el-table-column prop="updatedTime" label="更新时间" min-width="180" />
        <el-table-column label="操作" width="85" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <template v-slot:footer>
        <div class="maintenance-pagination">
          <el-pagination
            :current-page.sync="page"
            :page-size.sync="size"
            :total="total"
            :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            background
            @size-change="search"
            @current-change="load"
          />
        </div>
      </template>
    </table-panel>

    <el-dialog
      v-if="editVisible"
      :visible.sync="editVisible"
      :title="(form.id ? '编辑' : '新增') + '包件分类配置'"
      width="650px"
      :close-on-click-modal="false"
      :show-close="!saving"
      :close-on-press-escape="!saving"
    >
      <el-form
        :model="form"
        class="period-form"
        label-width="150px"
        size="small"
        :disabled="saving"
        @submit.native.prevent="save"
      >
        <el-form-item label="包件编码" required>
          <el-input
            v-model.trim="form.packCode"
            :disabled="!!form.id"
            maxlength="128"
          />
        </el-form-item>
        <el-form-item
          label="包件名称"
          required
        >
          <el-input
            v-model.trim="form.packName"
            maxlength="255"
            placeholder="请输入包件名称"
          />
        </el-form-item>
        <el-form-item label="上架分类" required>
          <el-select v-model="form.classCode">
            <el-option
              v-for="item in shelfOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="生产物流分类" required>
          <el-select v-model="form.productionDeliveryClassCode">
            <el-option
              v-for="item in productionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <el-alert v-if="editError" :title="editError" type="error" :closable="false" />
      <template v-slot:footer>
        <el-button :disabled="saving" @click="editVisible = false">
          取消
        </el-button>
        <el-button type="primary" :loading="saving" @click="save">
          保存
        </el-button>
      </template>
    </el-dialog>

    <import-dialog
      v-if="importVisible"
      :visible.sync="importVisible"
      title="包件分类配置导入"
      report-name="deliveryCyclePackClassImport"
      @refresh="search"
    />
  </content-panel>
</template>

<script>
import axios from '@/utils/axiosInstance'
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
import {
  clone,
  errorText,
  options,
  pageRequest,
  responseData
} from './model'
import ImportDialog from './components/ImportDialog'

const emptyFilter = () => ({
  packCode: '',
  packName: '',
  classCodes: [],
  productionDeliveryClassCodes: []
})

export default {
  name: 'PackageClassification',
  mixins: [pagePathMixin, tableMixin],
  components: { ImportDialog },
  data () {
    return {
      filter: emptyFilter(),
      applied: {},
      rows: [],
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      error: '',
      editError: '',
      requestId: 0,
      initId: 0,
      editVisible: false,
      importVisible: false,
      saving: false,
      templateData: '',
      form: {},
      shelfOptions: [],
      productionOptions: []
    }
  },
  created () {
    this.getTemplate()
    this.initialize()
  },
  beforeDestroy () {
    this.requestId++
    this.initId++
  },
  methods: {
    async initialize () {
      const id = ++this.initId
      this.filter = emptyFilter()
      this.shelfOptions = []
      this.productionOptions = []

      const dictionaries = Promise.all([
        this.$q.shippingPeriod.shelfOptions().then(responseData),
        this.$q.shippingPeriod.productionOptions().then(responseData)
      ])
        .then(([shelf, production]) => {
          if (id === this.initId) {
            this.shelfOptions = options(shelf)
            this.productionOptions = options(production)
          }
        })
        .catch(error => {
          if (id === this.initId) {
            this.error = errorText(error)
          }
        })

      await Promise.all([this.search(), dictionaries])
    },
    search () {
      this.applied = {
        packCode: this.filter.packCode,
        packName: this.filter.packName,
        classCodes: this.filter.classCodes,
        productionDeliveryClassCodes: this.filter.productionDeliveryClassCodes
      }
      this.page = 1
      return this.load()
    },
    reset () {
      this.filter = emptyFilter()
      this.search()
    },
    async load () {
      const id = ++this.requestId
      this.loading = true
      this.error = ''

      try {
        const data = responseData(
          await this.$q.shippingPeriod.classifications({
            data: pageRequest(this.page, this.size, this.applied)
          })
        )

        if (id === this.requestId) {
          this.rows = data.records || []
          this.total = Number(data.total) || 0
        }
      } catch (error) {
        if (id === this.requestId) {
          this.rows = []
          this.total = 0
          this.error = errorText(error)
        }
      } finally {
        if (id === this.requestId) {
          this.loading = false
        }
      }
    },
    async getTemplate () {
      const res = await axios.get(
        '/qu-platform-excel-api/excel/cfg/getTemplate/deliveryCyclePackClassImport'
      )
      this.templateData = res.data
    },
    downLoadTemplate () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        this.downLoad(this.templateData.templatePath, `${this.templateData.fileName}.XLSX`)
        loading.close()
      }, 300)
    },
    downLoad (path, name) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', path, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(xhr.response, name)
          } else {
            const link = document.createElement('a')
            const body = document.querySelector('body')
            link.href = window.URL.createObjectURL(xhr.response)
            link.download = name
            link.style.display = 'none'
            body.appendChild(link)
            link.click()
            body.removeChild(link)
            window.URL.revokeObjectURL(link.href)
          }
        }
      }
      xhr.send()
    },
    edit (row) {
      this.form = row
        ? clone(row)
        : {
          packCode: '',
          packName: '',
          classCode: '',
          productionDeliveryClassCode: ''
        }
      this.editError = ''
      this.editVisible = true
    },
    async save () {
      if (this.saving) return

      this.editError = ''
      if (
        !this.form.packCode ||
        !this.form.packName ||
        !this.form.classCode ||
        !this.form.productionDeliveryClassCode
      ) {
        this.editError = '请完整填写包件编码、包件名称、上架分类和生产物流分类'
        return
      }

      this.saving = true

      try {
        const data = {
          ...(this.form.id ? { id: this.form.id } : {}),
          packCode: this.form.packCode,
          packName: this.form.packName,
          classCode: this.form.classCode,
          productionDeliveryClassCode: this.form.productionDeliveryClassCode
        }
        const action = data.id ? 'updateClassification' : 'saveClassification'
        responseData(await this.$q.shippingPeriod[action]({ data }))
        this.editVisible = false
        this.$message.success('保存成功，下一个数据版本生效')
        await this.search()
      } catch (error) {
        this.editError = errorText(error)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style src="./style.css"></style>

<style scoped>
.maintenance-pagination {
  text-align: right;
}
</style>
